import React from 'react'
import {cn} from "@gettactic/helpers";

type Props = React.HTMLAttributes<HTMLDivElement>;

const styles = Object.freeze({
  base: 'p-4'
});

export const CardBody = React.forwardRef<HTMLDivElement, Props>(
  function CardBody(props, ref) {
    const { className, children, ...other } = props;

    return (
      <div className={cn(styles.base, className)} ref={ref} {...other}>
        {children}
      </div>
    );
  }
);